import {
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    Inject,
    Input,
    Output,
    PLATFORM_ID,
    ViewChild
} from '@angular/core';
import {Store} from '@ngrx/store';
import {AppState} from '@store/state/app.state';
import {login} from '@store/actions/authentication.action';
import {take} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {Router} from '@angular/router';
import {FormStatus} from '@iw-shop/forms/components/submit-button/submit-button.component';
import {faEnvelope, faLock} from "@fortawesome/free-solid-svg-icons";
import {ConfigState} from "@store/state/config.state";
import {isPlatformBrowser} from "@angular/common";

@Component({
    selector: 'iw-shop-user-login',
    standalone: false,
    templateUrl: './user-login.component.html',
    styleUrls: ['./user-login.component.scss']
})
export class UserLoginComponent implements AfterViewInit{
    @ViewChild('usernameInput') usernameInputRef!: ElementRef<HTMLInputElement>;

    @Input() title: string = 'Ich bin bereits Kunde';
    @Input() buttonClass: string = 'is-primary';
    @Input() focusOn?: 'usernameInput';
    @Output() onLoginSuccess: EventEmitter<any> = new EventEmitter();
    @Output() onClickLostPasswordLink: EventEmitter<any> = new EventEmitter();

    protected readonly isBrowser: boolean;

    form: {
        username: string,
        password: string
    } = {username: '', password: ''};

    formStatus: FormStatus = null;

    errorMsg$: Observable<string | undefined>;
    config$: Observable<ConfigState>;

    constructor(private store: Store<AppState>, private router: Router, @Inject(PLATFORM_ID) platformId: Object) {
        this.isBrowser = isPlatformBrowser(platformId);
        this.errorMsg$ = this.store.select(state => state.authentication.errorMsg);
        this.config$ = this.store.select(state => state.config);
    }

    ngAfterViewInit() {
        if(this.isBrowser && this.focusOn == 'usernameInput' ){
            //this.focusUsernameInput();
        }

    }
    focusUsernameInput() {
        // Use setTimeout to ensure it runs after DOM update
       /* setTimeout(() => {
            this.usernameInputRef?.nativeElement.focus();
        });*/
    }


    setLoginSuccess() {
        this.formStatus = 'success';

        setTimeout(() => {
            this.formStatus = null;
            this.form.username = '';
            console.log('success');
            this.onLoginSuccess.emit();
        }, 1000);
    }

    setLogin() {
        this.formStatus = 'loading';
        this.store.dispatch(login({username: this.form.username, password: this.form.password}));
        this.errorMsg$
            .pipe(
                take(2)
            )
            .subscribe(
                r => {
                    if (r) {
                        this.formStatus = 'error';
                        this.form.password = '';
                        setTimeout(() => {
                            this.formStatus = null;
                        }, 1000);
                    }
                }
            )
        this.store.select(state => state.storage.userId)
            .pipe(
                take(2)
            )
            .subscribe(
                res => {
                    if (res) {
                        this.form = {username: '', password: ''};
                        this.setLoginSuccess();
                    }
                }
            );
    }

    protected readonly faEnvelope = faEnvelope;
    protected readonly faLock = faLock;
}
